export const AddressTypes = [
  { value: 1, name: 'Residencial' },
  { value: 2, name: 'Comercial' }
]

export const States = [
  { value: 1, name: 'Acre', sigla: 'AC' },
  { value: 2, name: 'Alagoas', sigla: 'AL' },
  { value: 3, name: 'Amapá', sigla: 'AP' },
  { value: 4, name: 'Amazonas', sigla: 'AM' },
  { value: 5, name: 'Bahia', sigla: 'BA' },
  { value: 6, name: 'Ceará', sigla: 'CE' },
  { value: 7, name: 'Distrito Federal', sigla: 'DF' },
  { value: 8, name: 'Espírito Santo', sigla: 'ES' },
  { value: 9, name: 'Goiás', sigla: 'GO' },
  { value: 10, name: 'Maranhão', sigla: 'MA' },
  { value: 11, name: 'Mato Grosso', sigla: 'MT' },
  { value: 12, name: 'Mato Grosso do Sul', sigla: 'MS' },
  { value: 13, name: 'Minas Gerais', sigla: 'MG' },
  { value: 14, name: 'Paraná', sigla: 'PR' },
  { value: 15, name: 'Paraíba', sigla: 'PB' },
  { value: 16, name: 'Pará', sigla: 'PA' },
  { value: 17, name: 'Pernambuco', sigla: 'PE' },
  { value: 18, name: 'Piauí', sigla: 'PI' },
  { value: 19, name: 'Rio de Janeiro', sigla: 'RJ' },
  { value: 20, name: 'Rio Grande do Norte', sigla: 'RN' },
  { value: 21, name: 'Rio Grande do Sul', sigla: 'RS' },
  { value: 22, name: 'Rondonia', sigla: 'RO' },
  { value: 23, name: 'Roraima', sigla: 'RR' },
  { value: 24, name: 'Santa Catarina', sigla: 'SC' },
  { value: 25, name: 'Sergipe', sigla: 'SE' },
  { value: 26, name: 'São Paulo', sigla: 'SP' },
  { value: 27, name: 'Tocantins', sigla: 'TO' }
]



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Address/enum.js